import { useQuery } from 'react-query';
import request from '../helpers/request';

const getWarrantyInfo = async (requestId) => {
  return await request.get(
    `/Warranty/info/${requestId}`,
    {},
    'Произошла ошибка при загрузке организации',
    {}
  );
};

const useWarrantyInfo = (requestId) =>
  useQuery([`contractor`, requestId], () => getWarrantyInfo(requestId), {
    placeholderData: {},
    enabled: !!requestId,
  });

export default useWarrantyInfo;
